import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Role } from "../../models/RoleModel";
import { User } from "../../models/UserModel";

// src/features/auth/userDetailSlice.ts

interface UserState {
  policies: string[];
  role: string | null;
  id: string;
  fullname: string;
  email: string;
  gender: string;
  cellphoneNumber: string;
}

const initialState: UserState = {
  policies: [],
  role: null,
  id: "",
  fullname: "",
  email: "",
  gender: "",
  cellphoneNumber: "",
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setPoliciesAndRole(
      state,
      action: PayloadAction<{ policies: string[]; role: string }>
    ) {
      state.policies = action.payload.policies;
      state.role = action.payload.role;
    },
    setUserDetails(state, action: PayloadAction<{ user: User }>) {
      state.id = action.payload.user.id;
      state.fullname = action.payload.user.fullname;
      state.email = action.payload.user.email;
      state.cellphoneNumber = action.payload.user.cellphoneNumber;
      state.gender = action.payload.user.gender;
    },
    clearUserDetails(state) {
      state.id = "";
      state.fullname = "";
      state.email = "";
      state.cellphoneNumber = "";
      state.gender = "";
      state.role = null;
      state.policies = [];
    },
  },
});

export const { setUserDetails, clearUserDetails, setPoliciesAndRole } =
  userSlice.actions;
export default userSlice.reducer;
